module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/how-to-enjoy-sola-01-75bdd861bbd244f96b7a7078d13dcb88.jpg";